import type { PayslipItem } from '@thrivehrm/shared';

const MONTHS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

/**
 * A payslip's heading: the month for monthly runs ("September 2026"); bonus / LTA / settlement
 * payslips go by their run's name, since a month may have several (FR-PAY-13).
 */
export function payslipTitle(p: Pick<PayslipItem, 'period' | 'runType' | 'runName'>): string {
  return p.period && p.runType === 'MONTHLY'
    ? `${MONTHS[p.period.month - 1] ?? ''} ${String(p.period.year)}`
    : p.runName;
}
